const PackageOptionsStyles = () => ({
  main: {
    '& .ant-input-number-input': {
      borderRadius: 4,
      width: '100%',
    },
    '.anticon svg': {
      color: '#eeeeee',
    },
    '& .ant-form-item': {
      margin: 0,
      padding: 0,
    },
  },
  modal: {
    '& .ant-modal-header': {
      borderBottom: '1px solid #E8E8E8',
      padding: '16px 24px',
    },
    '& .ant-modal-title': {
      fontSize: '18px',
      fontWeight: 500,
    },
    '& .ant-modal-body': {
      padding: '20px 24px',
      height: '500px',
      overflowY: 'auto',
    },
    '& .ant-modal-close': {
      display: 'none',
    },
  },
  customCloseButton: {
    position: 'absolute',
    top: '16px',
    left: '16px',
    cursor: 'pointer',
    zIndex: 1000,
  },
  quantityRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
  },
  selectLabel: {
    font: 'Open Sans Regular',
    fontSize: 10,
    marginBottom: 6,
    letter: 'normal',
  },
  itemName: {
    font: 'Open Sans SemiBold',
    fontSize: 10,
  },
  inputQuantityCol: {
    padding: '0 4px',
  },
  inputQuantity: {
    width: '100%',
    margin: '0 4px',
    borderRadius: 4,
  },
  tableHeader: {
    fontSize: 10,
  },
  deleteOptionIcon: {
    alignItems: 'center',
    height: 30,
  },
  deleteIcon: {
    display: 'flex',
    margin: '0 8px',
    alignItems: 'center',
  },
  footer: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '12px',
  },
  acceptButton: {
    backgroundColor: '#0E2C53 !important',
    textAlign: 'center',
    border: '1px solid #0E2C53',
    '&:hover': {
      backgroundColor: '#0E2C53 !important',
    },
    color: '#fff !important',
  },
  additionalAmount: {
    height: 32,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'center',
    marginLeft: '16px',
    alignSelf: 'center',
  },
  tableHeaderRowQuantity: {
    marginTop: 5,
    marginLeft: 10,
    marginBottom: -8,
  },
  tableHeaderRowPrice: {
    marginTop: 5,
    marginBottom: -8,
  },
  formItem: {
    margin: 0,
    padding: 0,
    marginBottom: 0,
    width: '95%',
  },
  warningNote: {
    backgroundColor: '#FFF9C4',
    padding: '12px 16px',
    borderRadius: '4px',
    marginBottom: '24px',
  },
  warningText: {
    fontSize: '14px',
    color: '#5D4037',
  },
  headerRow: {
    marginBottom: '10px',
  },
  columnHeader: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#424242',
  },
  inputRow: {
    marginBottom: '16px',
    alignItems: 'center',
  },
  inputCol: {
    display: 'flex',
    alignItems: 'center',
  },
  unitPrice: {
    fontSize: '14px',
    color: '#424242',
  },
  selectedItem: {
    fontSize: '14px',
    color: '#424242',
    paddingRight: '10px',
  },
  addMoreButtonWrapper: {
    marginTop: '16px',
    marginBottom: '24px',
    textAlign: 'left',
  },
  closeIconWrapper: {
    position: 'absolute',
    left: '24px',
    top: '16px',
    fontSize: '18px',
    cursor: 'pointer',
  },
  addMoreButton: {
    padding: '0px',
    border: 'none',
    boxShadow: 'none',
    color: '#1890ff',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
  },
  addMoreIcon: {
    color: '#1890ff',
  },
  cancelButton: {
    borderRadius: '4px',
    color: '#0E2C53 !important',
    textAlign: 'center',
    '&:hover': {
      color: '#0E2C53 !important',
    },
  },
  proceedButton: {
    borderRadius: '4px',
  },
});

export default PackageOptionsStyles;
